import { stringify } from 'query-string';
import { performPutRequest, performPostRequest } from '@atlassian/jira-fetch';
import getXsrfToken from '@atlassian/jira-platform-xsrf-token';
import type { IssueKey } from '@atlassian/jira-shared-types';

const getFieldUpdate = <T,>(fieldId: string, value: T) => ({
	fields: {
		[fieldId]: value,
	},
});

export type CardUpdateRestProps<T> = {
	issueKey: IssueKey;
	fieldId: string;
	newValue: T;
};

export type CardUpdateRestPropsClassic<T> = {
	fieldId: string;
	newValue: T;
	cardId: number;
	fieldsToForcePresent?: string;
};

const cardUpdateRest = <T, ReturnType>({
	fieldId,
	issueKey,
	newValue,
}: CardUpdateRestProps<T>): Promise<ReturnType> =>
	performPutRequest(`/rest/api/3/issue/${issueKey}/`, {
		body: JSON.stringify(getFieldUpdate(fieldId, newValue)),
	});

export const cardUpdateRestClassic = <T, ReturnType>({
	fieldId,
	cardId,
	newValue,
	fieldsToForcePresent,
}: CardUpdateRestPropsClassic<T>): Promise<ReturnType> =>
	performPostRequest('/secure/AjaxIssueAction.jspa?decorator=none', {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: stringify({
			issueId: cardId,
			[fieldId]: newValue,
			atl_token: getXsrfToken(),
			skipScreenCheck: true,
			singleFieldEdit: true,
			fieldsToForcePresent,
		}),
	});

export default cardUpdateRest;
